function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M118.943 77.5237C118.943 85.326 124.542 91.4519 133.385 91.4519H141.549V84.068H134.12C129.37 84.068 126.749 81.2306 126.749 77.5237C126.749 73.8175 129.37 70.9787 134.12 70.9787H141.549V63.5962H133.385C124.542 63.5962 118.943 69.7207 118.943 77.5237Z",
  fill: "#CC0033"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M208.463 63.25C205.474 63.25 202.688 63.8586 199.076 66.3101C195.464 63.8586 192.676 63.25 189.687 63.25C183.036 63.25 178.39 67.8562 178.39 74.49V91.452H186.194V74.8834C186.194 72.0488 187.911 70.6332 190.728 70.6332C193.707 70.6332 195.179 72.13 195.179 74.526V91.452H202.973V74.526C202.973 72.13 204.445 70.6332 207.424 70.6332C210.241 70.6332 211.956 72.0488 211.956 74.8834V91.452H219.762V74.49C219.762 67.8562 215.116 63.25 208.463 63.25Z",
  fill: "#CC0033"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M238.503 63.25C229.23 63.25 223.99 70.5291 223.99 77.5293C223.99 84.5087 229.23 91.7961 238.503 91.7961C247.758 91.7961 253 84.5087 253 77.5293C253 70.5291 247.758 63.25 238.503 63.25ZM238.493 84.4129C234.147 84.4129 231.795 81.0016 231.795 77.5223C231.795 74.0438 234.147 70.6332 238.493 70.6332C242.84 70.6332 245.195 74.0438 245.195 77.5223C245.195 81.0016 242.84 84.4129 238.493 84.4129Z",
  fill: "#CC0033"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1005 51V65.0055C72.214 63.905 69.9547 63.2499 67.3392 63.2499C57.9768 63.2499 53 70.5901 53 77.5292C53 84.4475 57.9768 91.796 67.3392 91.796C74.3727 91.796 76.9993 88.3737 81.9065 86.1081C81.9065 84.5016 81.9065 84.6578 81.9065 51H74.1005ZM60.8066 77.5223C60.8066 74.0437 63.1596 70.6331 67.5046 70.6331C71.8516 70.6331 74.1254 73.8987 74.2019 77.3433V77.7013C74.1254 81.1459 71.8516 84.4128 67.5046 84.4128C63.1596 84.4128 60.8066 81.0015 60.8066 77.5223Z",
  fill: "#CC0033"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M105.06 51.0029L105.049 52.9063H102.306L102.318 59.8253H100.29V52.9063H97.5486V51.0029C97.5486 51.0029 105.047 51.0029 105.06 51.0029Z",
  fill: "#CC0033"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M114.064 51.0029V52.9063H111.321V59.8253H109.294V52.9063H106.551V51.0029C106.551 51.0029 114.05 51.0029 114.064 51.0029Z",
  fill: "#CC0033"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M89.908 51L93.8947 56.6595L93.894 51.0041H95.8342V59.8251H93.7066L89.7433 54.1843V59.8251H87.7996V51H89.908Z",
  fill: "#CC0033"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M100.817 63.25C91.5458 63.25 86.3037 70.5291 86.3037 77.5293C86.3037 84.5087 91.5458 91.7961 100.817 91.7961C110.073 91.7961 115.315 84.5087 115.315 77.5293C115.315 70.5291 110.073 63.25 100.817 63.25ZM100.808 84.4129C96.4626 84.4129 94.1104 81.0016 94.1104 77.5223C94.1104 74.0438 96.4626 70.6332 100.808 70.6332C105.155 70.6332 107.509 74.0438 107.509 77.5223C107.509 81.0016 105.155 84.4129 100.808 84.4129Z",
  fill: "#CC0033"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M159.665 63.25C150.394 63.25 145.151 70.5291 145.151 77.5293C145.151 84.5087 150.394 91.7961 159.665 91.7961C168.92 91.7961 174.162 84.5087 174.162 77.5293C174.162 70.5291 168.92 63.25 159.665 63.25ZM159.656 84.4129C155.311 84.4129 152.957 81.0016 152.957 77.5223C152.957 74.0438 155.311 70.6332 159.656 70.6332C164.002 70.6332 166.356 74.0438 166.356 77.5223C166.356 81.0016 164.002 84.4129 159.656 84.4129Z",
  fill: "#CC0033"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoDocomo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDocomo);
export default __webpack_public_path__ + "static/media/logo_docomo.ac1c30a2.svg";
export { ForwardRef as ReactComponent };